<template>
  <div>
    <!-- Favicon. -->
  </div>
</template>

<script lang="ts" setup>
import { DomainId } from '#graphql-operations'

const { activeDomain } = useSiteContext()

function getFaviconFolder(domain: DomainId): string {
  switch (domain) {
    case DomainId.rapperswil_zuerichsee_ch:
      return 'rzst'
    case DomainId.eyz:
      return 'eyz'
  }

  return 'zt'
}

const folder = getFaviconFolder(activeDomain)

useHead({
  link: [
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: `/favicon/${folder}/favicon_180.png`,
      key: 'icon-180',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: `/favicon/${folder}/favicon_32.png`,
      sizes: '32x32',
      key: 'icon-32',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: `/favicon/${folder}/favicon_192.png`,
      sizes: '192x192',
      key: 'icon-192',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: `/favicon/${folder}/favicon_512.png`,
      sizes: '512x512',
      key: 'icon-512',
    },
    {
      rel: 'icon',
      type: 'image/png',
      href: `/favicon/${folder}/favicon_16.png`,
      sizes: '16x16',
      key: 'icon-16',
    },
  ],
})
</script>
